export default {
  extension: {
    setting: {
      alertTitle: '标题',
      alertType: '类型',
      center: '文字居中',
      closable: '是否可关闭',
      closeText: '关闭按钮文字',
      collapseAccordion: '手风琴模式',
      collapseBorder: '边框',
      collapseItemBorder: '内边框',
      collapseItemDisabled: '禁用',
      collapseItemExpand: '展开',
      collapseItemIcon: '标题栏图标',
      collapseItemIsLink: '右侧箭头',
      collapseItemLabel: '描述',
      collapseItemLabelClass: '描述内容样式名',
      collapseItemLazyRender: '推迟渲染',
      collapseItemProperyDialogTitle: '折叠面板属性',
      collapseItemReadonly: '只读',

      collapseItemSize: '标题栏尺寸',
      collapseItemTitle: '主标题',
      collapseItemTitleClass: '主标题样式名',
      collapseItemValue: '副标题',
      collapseItemValueClass: '副标题样式名',
      description: '辅助性文字',
      effect: '显示效果',
      showIcon: '显示图标',
    },

    widgetLabel: {
      alert: '提示',
      collapse: '折叠面板',
    },
  },
};
